import React, { useRef, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/shownotes/NoteSection";

// Notes text box that grows to ~60% of the screen (full form width) while focused.
export default function ExpandField({ label, value, onChange, rows = 2, wide, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const focus = () => {
    setOpen(true);
    setTimeout(() => ref.current?.scrollIntoView({ block: "start", behavior: "smooth" }), 320);
  };
  return (
    <Field label={label} className={wide || open ? "sm:col-span-2" : ""}>
      <Textarea ref={ref} rows={rows} value={value || ""} onChange={(e) => onChange(e.target.value)} onFocus={focus} onBlur={() => setOpen(false)}
        data-expanded={open ? "true" : "false"} data-testid={testId}
        className={`scroll-mt-10 resize-none bg-white transition-[height,box-shadow] duration-300 ease-out ${open ? "h-[60dvh] shadow-lg" : rows >= 3 ? "h-20" : "h-16"}`} />
    </Field>
  );
}
